module.exports = __webpack_public_path__ + "img/12.ad3d2cbc.png";